import React from "react";
import Stack from "components/common/Stack";
import Text from "components/common/Text";
import Image from "components/common/Image";
import Box from "components/common/Box";
import { MOBILE_TITLE_SX } from "components/allInOneDashboard/constants/mobileTheme";

const SectionHeading = ({
  title,
  iconSrc,
  titleColor = "#111827",
  titleSx = null,
  subtitle = null,
  subtitleSx = null,
  afterTitle = null,
  rightContent = null,
  sx = null,
}) => {
  const titleNode = (
    <Text
      sx={{
        ...MOBILE_TITLE_SX,
        color: titleColor,
        ...titleSx,
      }}
    >
      {title}
    </Text>
  );

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent={rightContent ? "space-between" : "flex-start"}
      spacing={{ xs: 1, md: 1.5 }}
      sx={{
        mb: { xs: 2, md: 2.5 },
        gap: rightContent || afterTitle ? 2 : undefined,
        ...sx,
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={{ xs: 1, md: 1.5 }}
        sx={{ minWidth: 0, flexWrap: afterTitle ? "wrap" : "nowrap" }}
      >
        {iconSrc ? (
          <Box
            sx={{
              width: { xs: 28, md: "clamp(40px, 4.2vw, 62px)" },
              height: { xs: 28, md: "clamp(40px, 4.2vw, 62px)" },
              flexShrink: 0,
              "& img": { width: "100%", height: "100%", objectFit: "contain" },
            }}
          >
            <Image
              src={iconSrc}
              alt=""
              rootStyle={{ width: "100%", height: "100%" }}
            />
          </Box>
        ) : null}
        {subtitle ? (
          <Stack spacing={1} sx={{ minWidth: 0 }}>
            {titleNode}
            <Text sx={{ color: "#6B7280", ...subtitleSx }}>{subtitle}</Text>
          </Stack>
        ) : (
          titleNode
        )}
        {afterTitle}
      </Stack>
      {rightContent}
    </Stack>
  );
};

export default SectionHeading;
